module.exports = __webpack_public_path__ + "static/img/xiaohongmao.b937e59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xiaohongmao.jpg
// module id = V32A
// module chunks = 5